export default __webpack_public_path__ + "static/media/truck.f1997b1c.svg";